import { render, staticRenderFns } from "./SpaceTeams.vue?vue&type=template&id=523251ef&"
import script from "./SpaceTeams.vue?vue&type=script&lang=js&"
export * from "./SpaceTeams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports